import { createApi } from '@reduxjs/toolkit/query/react';
import { Widget } from 'widgets/models/WidgetModels';
import { axiosBaseQuery } from '../../../common/store/api/BaseQueryConfig';

// Define a service using a base URL and expected endpoints
export const getUserPreferenceApi = createApi({
    reducerPath: 'userPreference',
    baseQuery: axiosBaseQuery,
    tagTypes: ['widgetpreferences'],
    endpoints: builder => ({
        GetUserPreference: builder.query<Widget[], null>({
            query: name => `/DashboardWidgets/account`,
            providesTags: ['widgetpreferences'],
        }),
        CreateUserPreference: builder.mutation({
            query: userPreference => ({
                url: `/DashboardWidgets/account`,
                method: 'POST',
                body: userPreference,
            }),
            invalidatesTags: ['widgetpreferences'],
        }),
        DeleteUserPreference: builder.mutation({
            query(id) {
                return {
                    url: `/DashboardWidgets/account/${id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['widgetpreferences'],
        }),
        UpdateUserPreference: builder.mutation({
            query(body) {
                return {
                    url: `/DashboardWidgets/account`,
                    method: 'PATCH',
                    body,
                };
            },
            invalidatesTags: ['widgetpreferences'],
        }),
        UpdateWidgetOrder: builder.mutation({
            query(body) {
                return {
                    url: `/DashboardWidgets/account`,
                    method: 'PATCH',
                    body,
                };
            },
            async onQueryStarted(body, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                    getUserPreferenceApi.util.updateQueryData(
                        'GetUserPreference',
                        null,
                        () => {
                            return body;
                        }
                    )
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
            invalidatesTags: ['widgetpreferences'],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetUserPreferenceQuery,
    useCreateUserPreferenceMutation,
    useDeleteUserPreferenceMutation,
    useUpdateUserPreferenceMutation,
    useUpdateWidgetOrderMutation,
} = getUserPreferenceApi;
